module.exports = __webpack_public_path__ + "img/doc.d69722ee.png";